var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._g(_vm._b({class:{
    user__avatar: true,
    'user--unknown': _vm.isEmailEmpty,
  },style:({
    background: _vm.userAvatarColor,
  })},'div',_vm.$attrs,false),_vm.$listeners),[_vm._v(" "+_vm._s(_vm.isEmailEmpty ? _vm.userName : _vm.userInitial)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }